////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const marketing = {
	[ActionsTypes.POST_MARKETING]: (state) =>
		update(state, {
			marketing: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.POST_MARKETING_SUCCESS]: (state, payload) => {
		const itemsCp = cloneDeep(payload.data.headerContent.contentPagined.content)
		const pagingCp = cloneDeep(payload.data.headerContent.contentPagined)
		const headerCp = cloneDeep(payload.data.headerParam.filters)
		return update(state, {
			marketing: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: itemsCp,
				},
				paging: {
					$set: pagingCp,
				},
				header: {
					$set: headerCp,
				},
			},
		})
	},
	[ActionsTypes.POST_MARKETING_FAILURE]: (state, payload) => {
		return update(state, {
			marketing: {
				error: {
					$set: payload.error,
				},
				isLoading: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.RESET_MARKETING]: (state) => {
		return update(state, {
			marketing: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				items: {
					$set: {},
				},
				paging: {
					$set: {},
				},
				header: {
					$set: {},
				},
			},
		})
	},
}

export default marketing
